import { useCallback, useState, useLayoutEffect } from 'react';
import { dispatcher } from 'dispatcher';

type UseImageFallbackProps = {
    initialSrc: string; fallbackSrc: string; gameCode: string;
}

export const useImageFallback = ({ initialSrc = '', fallbackSrc = '', gameCode }: UseImageFallbackProps) => {
    const [src, setSrc] = useState('');

    const handleError = useCallback(() => {
        dispatcher.dispatch('image:fail', { gameCode });
        setSrc(fallbackSrc);
    }, [fallbackSrc, gameCode]);

    const handleSetImage = useCallback((imageSource: string) => {
        const img = new Image();
        img.src = imageSource;

        img.onload = () => {
            setSrc(imageSource);
        };

        img.onerror = () => {
            setSrc(fallbackSrc);
        };
    }, [fallbackSrc]);

    useLayoutEffect(() => {
        setSrc(initialSrc);
    }, [initialSrc]);

    return { src, handleError, handleSetImage };
};
